import React from 'react';
import { createRoot } from 'react-dom/client';
import ConfirmationBox from 'src/components/ConfirmationBox/ConfirmationBox.jsx';
import Promise from './Promise';

// eslint-disable-next-line import/no-default-export
export default async function confirmation(message, result) {
    return new Promise((resolve) => {
        const node = document.getElementById('confirmations');
        const root = createRoot(node);
        function unmount() {
            setTimeout(() => root.unmount(node));

        }

        function finish() {
            resolve(result);
            unmount();
        }

        root.render(
            <ConfirmationBox
                message={ message }
                onConfirm={ finish }
                onReject={ unmount }
            />
        );
    });
}
